import { memo } from "react";
import Google from "./google";
import { useRouter } from "next/router";
import PropTypes from "prop-types";
import { useTranslation } from "next-i18next";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";

const Reviews = memo(({ className = "" }) => {
  const { t } = useTranslation("home");
  const router = useRouter();
  const lang = router.locale || "en";

  return (
    <div
      className={`w-full [background:linear-gradient(180deg,_#030426,_#000)] border-gray-200 border-solid border-b-[1px] box-border px-[24px] md:px-[60px] lg:px-[80px] xl:px-[80px] py-[40px] md:py-[40px] lg:py-[60px] lg:py-[60px]  ${className}`}
    >
      <p className="text-[16px] sm:text-[18px] leading-[150%] mb-5 text-white text-center italic">
        {t("home.reviews.content")}
      </p>
      <div className="w-full max-w-[1600px] mx-auto">
        <Swiper
          dir={lang === "ar" ? "rtl" : "ltr"}
          modules={[Autoplay]}
          spaceBetween={16}
          slidesPerView={1}
          breakpoints={{
            640: {
              slidesPerView: 2,
            },
            768: {
              slidesPerView: 2,
            },
            1024: {
              slidesPerView: 3,
            },
            1028: {
              slidesPerView: 4,
            },
          }}
          // autoplay={{ delay: 5000 }}
          autoplay={{
            delay: 5000,
            disableOnInteraction: false,
            pauseOnMouseEnter: true,
          }}
          className="w-full"
        >
          <SwiperSlide>
            <Google icon="/icons/google.png" title={t("home.reviews.google")} />
          </SwiperSlide>
          <SwiperSlide>
            <Google
              icon="/icons/facebook.png"
              title={t("home.reviews.facebook")}
            />
          </SwiperSlide>
          <SwiperSlide>
            <Google icon="/icons/clutch.png" title={t("home.reviews.clutch")} />
          </SwiperSlide>
          <SwiperSlide>
            <Google
              icon="/icons/goodfirms.png"
              title={t("home.reviews.goodFirm")}
            />
          </SwiperSlide>
        </Swiper>
      </div>
    </div>
  );
});

Reviews.propTypes = {
  className: PropTypes.string,
};

export default Reviews;
